<template>
  <div class="Article-content">
    <h1>What is coin leasing in V SYSTEMS?</h1>
    <p>For detailed explanation about coin leasing, please refer to the SPoS whitepaper.</p>

    <h2>1. Introduction to coin leasing</h2>
    <p>Coin leasing is the way for VSYS coin holders in the V SYSTEMS public chain to assist
      supernodes in coin minting, and participate in the self-governance blockchain ecosystem.
      Similar to cryptocurrency mining, coin holders can earn VSYS coins during the process.
    </p>
    <p class="center"><img src="../assets/minting_process.png" class="img-process"
                           alt="Mintint Process"></p>
    <p>The above diagram illustrates the role of VSYS coins in supernode minting as well as the
      reward sharing scheme by supernodes to coin holders.
    </p>
    <p>During coin leasing, however, the leased VSYS coins are not actually transferred into the
      supernode’s wallet. This is due to V SYSTEMS’ pioneering cold minting technology, where VSYS
      coins are remotely mapped to the supernode. This design brings a very high level of security,
      as the VSYS coins remain in the owner’s wallet during the entire coin leasing process.
    </p>

    <h2>2. Reward calculation for coin leasing</h2>
    <p>The basic formula for calculating reward from coin leasing:</p>
    <p class="center"><img src="../assets/minting_calculate.png"
                           alt="Computational formula of Minting"></p>
    <p>MAB = Minting Average Balance (number of VSYS coins with over 1 day of age)</p>
    <p>According to the SPoS design, the total number of coins minted by all supernodes in one day
      is 777,600. Dividing this number with the number of supernodes will result in the number of
      VSYS coins minted by one supernode in a day.
    </p>
    <p>There are 15 fully-operating supernodes at the launch of the mainnet. As functions and the
      ecosystem expand, the number of supernodes will rise to 30 and ultimately 60.
    </p>

    <h2>3. List of supernodes</h2>
    <p>You can find out about the V SYSTEMS supernodes in the supernode market created by V SYSTEMS
      community fans. Select the one that you are most satisfied with in regards to the vision,
      reward system and more, and start leasing your coin to the respective supernode to participate
      in coin minting.
    </p>
    <p>It is the duty for every coin holder to safeguard a decentralized environment. Choosing a
      supernode that is fostering the growth of the ecosystem is a key to building a stable network.
    </p>
    <p>As a start, the supernode market can be found at vsysrate.com. More sites will be announced,
      and interested parties are welcomed to build similar marketplace as well.
    </p>

    <h2>4. Step-by-step guide to coin leasing</h2>
    <p><strong>Step 1:</strong> In your VSYS coin wallets, open a wallet for coin deposit.</p>
    <p><strong>Step 2:</strong> Select the “Minting” function.</p>
    <p class="center"><img class="phone" src="../assets/minting_screenshot.png"
                           alt="Minting Screenshot"></p>
    <p><strong>Step 3:</strong> Enter the supernode address (find the coin leasing address of your
      preferred
      supernode in the supernode market)
    </p>
    <p><strong>Step 4:</strong> Confirm</p>
  </div>
</template>

<script>

  export default {
    name: 'Leasing',
  };
</script>

<style lang="scss">
  .Article-content {
    font-size: 0.14rem;
    .phone {
      max-width: 300px;
    }

    .img-process {
      max-height: 217px;
    }
  }
</style>
